export function pathFromFolderchain(chain) {
  const array = [...chain];
  let path = '/';
  if (array[0] && array[0].id == 'root') {
    array.shift();
  }
  array.map((each) => {
    path += `${each.name}/`;
  });
  return path;
}
